var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Paper, useTheme, Stack, Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import { redirect, useLoaderData } from "react-router-dom";
import { axiosPrivate } from "../api/axios";
import { Routes } from "../Shared/components/Navigation/navigationUtils";
import { GiftCardText } from "./GiftCard-types";
import { GiftCardForm } from "./GiftCardForm";
export const GiftCard = () => {
    const theme = useTheme();
    const { pageDescription } = useLoaderData();
    return (_jsx(Stack, Object.assign({ justifyContent: "center", alignItems: "center", my: 4 }, { children: _jsx(Paper, Object.assign({ sx: {
                width: "100%",
                padding: theme.spacing(5),
            } }, { children: _jsxs(Stack, Object.assign({ width: "100%", spacing: 2 }, { children: [_jsxs(Box, { children: [_jsx(Typography, Object.assign({ variant: "h2", color: "primary", gutterBottom: true }, { children: GiftCardText.TITLE })), _jsx(Typography, Object.assign({ gutterBottom: true }, { children: pageDescription !== null && pageDescription !== void 0 ? pageDescription : GiftCardText.DEFAULT_DESCRIPTION }))] }), _jsx(GiftCardForm, {})] })) })) })));
};
export const GiftCardLoader = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const data = yield axiosPrivate.get(`/React/GetGiftCardConfigurations`).then((res) => {
            return res.data;
        });
        if (!data.success) {
            return redirect(Routes.NOT_FOUND);
        }
        if (data.redirectUrl) {
            return redirect(data.redirectUrl);
        }
        return Object.assign({}, data);
    }
    catch (e) {
        console.error(e);
        throw e;
    }
});
